<template>
	<div :class="bemm('')">
		<div :class="bemm('content')">
			<div :class="bemm('icon-container')">
				<Icon :name="Icons.HOURGLASS_END" color="warning" size="xlarge" />
			</div>
			<p>{{ t('auth.sessionExpiring.countdownLead') }}</p>
			<h2 :class="bemm('countdown')">{{ formattedTime }}</h2>
			<p>{{ t('auth.sessionExpiring.question') }}</p>
		</div>

		<div :class="bemm('footer')">
			<Button variant="ghost" @click="onIgnore()">
				{{ t('common.actions.ignore') }}
			</Button>
			<Button
				:status="isRefreshing ? Status.LOADING : null"
				:disabled="isRefreshing"
				@click="onStayLoggedIn()"
			>
				{{ t('auth.sessionExpiring.stayLoggedIn') }}
			</Button>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useBemm } from 'bemm';
import { Button } from '@arritech/ui/Button';
import { Status } from '@arritech/shared/types';
import { Icons } from '@arritech/ui';
import Icon from '@arritech/ui/Icon/Icon.vue';
import type { SessionExpiringPromptPanelProps } from './SessionExpiringPromptPanel.model';

const { t } = useI18n();
const bemm = useBemm('session-expiring-prompt');

withDefaults(defineProps<SessionExpiringPromptPanelProps>(), {
	formattedTime: '00:00',
	isRefreshing: false,
	onIgnore: () => undefined,
	onStayLoggedIn: () => undefined,
});
</script>

<style lang="scss">
.session-expiring-prompt {
	&__content {
		text-align: center;
		padding: var(--space) 0;

		p {
			margin: var(--space-xs) 0;
			color: var(--color-text-muted);
		}
	}

	&__countdown {
		margin-bottom: var(--space-l);
		color: var(--color-error);
		font-weight: var(--font-weight-bold);
	}

	&__icon-container {
		margin-bottom: var(--space);

		.ar-icon {
			font-size: var(--font-size-xxl);
		}
	}

	&__footer {
		display: flex;
		justify-content: flex-end;
		gap: var(--space-s);
	}
}
</style>
